import { render } from "./AccountCreation.vue?vue&type=template&id=25bc1f54&ts=true"
import script from "./AccountCreation.vue?vue&type=script&lang=ts"
export * from "./AccountCreation.vue?vue&type=script&lang=ts"

import "./AccountCreation.vue?vue&type=style&index=0&id=25bc1f54&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/CRM/OutlookAddin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__